<template>
  <SoPageWithHeader title="Readings">
    <MeterReadingsListTable />
  </SoPageWithHeader>
</template>

<script lang="ts">
  import SoPageWithHeader from "@/components/templates/SoPageWithHeader.vue"
  import MeterReadingsListTable from "@/views/operations/meterReadings/components/MeterReadingsListTable.vue"
  import { defineComponent } from "vue"

  export default defineComponent({
    components: {
      MeterReadingsListTable,
      SoPageWithHeader,
    },
  })
</script>
